import { render, staticRenderFns } from "./LostUser.vue?vue&type=template&id=62cb2881&scoped=true&"
import script from "./LostUser.vue?vue&type=script&lang=ts&"
export * from "./LostUser.vue?vue&type=script&lang=ts&"
import style0 from "./LostUser.vue?vue&type=style&index=0&id=62cb2881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb2881",
  null
  
)

export default component.exports